import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Element } from '../../../../common/html/element'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'
import { COMPONENTS } from '../../../../routers/constants'
import { selectTopIndustryPlayersById } from '../../store/slice'

export const CompanyName = ({ rowId }) => {
  const data = useSelector(selectTopIndustryPlayersById(rowId))
  const isRedirect = data.allowRedirectLink
  const Wrapper = isRedirect ? Link : Element

  return (
    <Element
      style={{
        color: isRedirect ? '#2C73E8' : 'inherit',
        cursor: isRedirect ? 'pointer' : 'default',
      }}
    >
      <Wrapper
        to={`${COMPONENTS.companyAnalysis.components.summary.route}?organizationId=${data.organizationId}`}
        target="_blank"
      >
        <TextEllipsisStaticLine
          text={data.companyName}
          isI18n={false}
          lineClamp={1}
        />
      </Wrapper>
    </Element>
  )
}
